import React, {useEffect, useState} from "react";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";
import SettingsPanelDateTimeSpanSelector from "../CommonComponents/SettingsPanelDateTimeSpanSelector";
import {withNamespaces} from "react-i18next";
import SimpleBar from "simplebar-react";
import axios from "axios";

function ReservierungsListeFilter(props) {
    let {
        translation, departmentChanged,
        selectedFromDateTimeChanged, selectedTillDateTimeChanged, timeSpanSendButtonClicked,
    } = props;

    const link = localStorage.getItem('link') + '/api/ReservationService';
    const userDepartmentId = parseInt(localStorage.getItem("departmentId"));
  
    const [selectedDepartment, setSelectedDepartment] = useState();
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, []);

    const loadData = () => {
        axios.get(link + '/DepartmentSelections', {}).then((response) => {
            let departments = response.data;
            departments.unshift({value: null, label: props.t("allgemein.alle")});
            setDepartments(departments);

            const _userDepartment = departments.find(department => department.value === userDepartmentId);
            setSelectedDepartment(_userDepartment);
            departmentChanged?.(_userDepartment);
            console.log("userDepartment", _userDepartment);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
            });
    }

    return (
        <div className="content-group">
            <div className="content-group-name" style={{marginBottom: '0px'}}>
                {translation("allgemein.filter")}
            </div>
            <SimpleBar className="simplebar-se">
                <div className="content-group" style={{width: '100%'}}>
                    <div className="content-group-name">
                        {translation("userDepartments.department")}
                    </div>
                    <div className="typ-container-se">
                        <Select
                            styles={customStyles}
                            closeMenuOnSelect={true}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(department) => {
                                console.log("selectedDepartment changed", department);
                                setSelectedDepartment(department);
                                departmentChanged?.(department);
                            }}
                            options={departments}
                            value={selectedDepartment}
                        />
                    </div>
                </div>
                <SettingsPanelDateTimeSpanSelector
                    translation={translation}
                    fromDateChanged={(value) => selectedFromDateTimeChanged?.(value)}
                    tillDateChanged={(value) => selectedTillDateTimeChanged?.(value)}
                    sendButtonClicked={(from, till) => timeSpanSendButtonClicked?.(from, till)}
                />
            </SimpleBar>
        </div>
    );
}

export default withNamespaces()(ReservierungsListeFilter);
